import BannerLarge from './BannerLarge'

export * from './BannerLarge'

export default BannerLarge
